<template>
  <div>
    <Navbar />
    <div class="container-center pb-5">
      <router-view />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'AppLayoutDefault',
  components: {
    Navbar
  }
}
</script>